import PricesManagerByArticle from './PricesManagerByArticle'
export default PricesManagerByArticle
